import applyFilters from './apply-filters.js';

export default function($) {
  var selected_filter = 'all';
  var loaded_posts;
  var initially_loaded_posts = 10;

  $(document).on('change', '.filter-select', function(e) {
    var list = $(this).attr('data-list');
    selected_filter = $(this).val();

    // Loaded posts for blog section
    // THIS IS BAD BUT I'M TOO LAZY TO FIX DURING THIS REFACTOR
    if ($(this).hasClass('posts-filter-select')) {
      loaded_posts = initially_loaded_posts;
    } else {
      loaded_posts = -1;
    }

    applyFilters($, list, selected_filter, loaded_posts);
  });

  $('.filter-select').trigger('change');
}
